const themeConfig = window.SeuVinhoTheme || {
  defaultMode: 'light',
  storageKey: 'seu-vinho-theme',
};

const systemThemeQuery = window.matchMedia('(prefers-color-scheme: light)');

function getStoredTheme() {
  try {
    const value = window.localStorage.getItem(themeConfig.storageKey);
    return value === 'dark' || value === 'light' ? value : null;
  } catch (error) {
    return null;
  }
}

function resolveDefaultTheme() {
  if (themeConfig.defaultMode === 'system') return systemThemeQuery.matches ? 'light' : 'dark';
  return themeConfig.defaultMode === 'light' ? 'light' : 'dark';
}

function applyTheme(theme, preference = theme) {
  const resolvedTheme = theme === 'light' ? 'light' : 'dark';
  document.documentElement.dataset.theme = resolvedTheme;
  document.documentElement.dataset.themePreference = preference;
  document.documentElement.style.colorScheme = resolvedTheme;
  document.dispatchEvent(
    new CustomEvent('seu-vinho:theme-change', {
      detail: { theme: resolvedTheme, preference },
    })
  );
}

function handleStorage(event) {
  if (event.key !== themeConfig.storageKey) return;
  const storedTheme = getStoredTheme();
  applyTheme(storedTheme || resolveDefaultTheme(), storedTheme || themeConfig.defaultMode);
}

function handleSystemTheme() {
  if (themeConfig.defaultMode !== 'system' || getStoredTheme()) return;
  applyTheme(resolveDefaultTheme(), 'system');
}

window.addEventListener('storage', handleStorage);
systemThemeQuery.addEventListener('change', handleSystemTheme);

class ThemeModeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.label = this.querySelector('[data-theme-mode-label]');
    if (!this.button) return;

    this.handleClick = this.handleClick.bind(this);
    this.handleThemeChange = this.handleThemeChange.bind(this);

    this.button.addEventListener('click', this.handleClick);
    document.addEventListener('seu-vinho:theme-change', this.handleThemeChange);
    this.update(document.documentElement.dataset.theme || resolveDefaultTheme());
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    document.removeEventListener('seu-vinho:theme-change', this.handleThemeChange);
  }

  handleClick() {
    const currentTheme = document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
    const nextTheme = currentTheme === 'light' ? 'dark' : 'light';

    try {
      window.localStorage.setItem(themeConfig.storageKey, nextTheme);
    } catch (error) {
      // The visual preference still applies for this page when storage is unavailable.
    }

    applyTheme(nextTheme);
  }

  handleThemeChange(event) {
    this.update(event.detail.theme);
  }

  update(theme) {
    const isLight = theme === 'light';
    const actionLabel = isLight ? 'Ativar modo escuro' : 'Ativar modo claro';
    this.dataset.currentTheme = isLight ? 'light' : 'dark';
    this.button.setAttribute('aria-label', actionLabel);
    this.button.setAttribute('aria-pressed', String(isLight));
    this.button.setAttribute('title', actionLabel);
    if (this.label) this.label.textContent = actionLabel;
  }
}

if (!customElements.get('theme-mode-toggle')) {
  customElements.define('theme-mode-toggle', ThemeModeToggle);
}
